module.exports = __webpack_public_path__ + "img/nskyg.2ff9d066.png";